import axiosIns from '../../../xaxios';
import { obtenerUrlAPIPagos } from '../utils/funciones';

export default {
  async findOne(id, opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos(`detalles-plan-pagos-concepto-universidad/${id}`), {
      params: opciones.params,
    });
  },
};
